import * as companyManagementService from "../../../../services/company";
import * as originPackageService from "../../../../services/originPackage";
import * as settings from "../../../../services/settings";
import * as usersService from "../../../../services/users";

import { ArrowLeftOutlined, EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Transfer,
  Typography,
  notification,
} from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useTranslation } from "react-i18next";
import permissions from "../../../../../configs/permission";
import { useAccessToken } from "../../../../contexts/AccessTokenContext";
import { usePermission } from "../../../../hooks/usePermission";

// Extend dayjs with plugins
dayjs.extend(customParseFormat);

const isPassword = /^[A-Za-z0-9]+$/;
const TYPE_EDIT = "EDIT";
const TYPE_CREATE = "CREATE";

/** ล้าง password ที่ Chrome autofill — ไม่ใช้ค่าเหล่านี้ตอน submit (โดยเฉพาะโหมดแก้ไข) */
const PASSWORD_FIELD_NAMES = ["password", "confirm_password"];

const toIdOrNull = (v) => {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  return Number.isInteger(n) && n > 0 ? n : null;
};

const toNickNameOrNull = (v) => {
  if (v === null || v === undefined) return null;
  const s = String(v).trim();
  return s.length > 0 ? s : null;
};

export const CreateUserManagementPage = () => {
  const { isSuperuser, hasPermission } = usePermission();
  const { accessToken } = useAccessToken();
  const hasFetched = useRef(false);
  const [loading, setLoading] = useState(false);
  const [resetPasswordModalOpen, setResetPasswordModalOpen] = useState(false);
  const [resetPasswordLoading, setResetPasswordLoading] = useState(false);
  const [formUser] = Form.useForm();
  const [resetPasswordForm] = Form.useForm();
  const clearAutofillPasswordFields = useCallback(() => {
    formUser.setFields(
      PASSWORD_FIELD_NAMES.map((name) => ({ name, value: undefined, touched: false, errors: [] }))
    );
  }, [formUser]);
  const { Title } = Typography;
  const { t } = useTranslation("user", "buttons", "common");
  const [userData, setUserData] = useState({});
  const [stateType, setStateType] = useState(TYPE_CREATE);
  const [listUserManagerData, setListUserManagerData] = useState([]);
  const [listUserCompanyData, setListUserCompanyData] = useState([]);
  const [listUserSalesData, setListUserSalesData] = useState([]);
  const [listUserCustomerData, setListUserCustomerData] = useState([]);
  const [listWareHouseOrigin, setListWareHouseOrigin] = useState([]);
  const [listWareHouseDestination, setListWareHouseDestination] = useState([]);
  const [dateJoined, setDateJoined] = useState("");
  const [lastLogin, setLastLogin] = useState("");
  const [isValidateSalesId, setIsValidateSaleId] = useState(false);
  const [isValidateCustomerId, setIsValidateCustomerId] = useState(false);
  const [company, setCompany] = useState([]);
  const [searchCompanyData, setSearchCompanyData] = useState("");
  const [customerSaleId, setSaleId] = useState();
  const [customerId, setCustomerId] = useState();
  const [isSubmit, setIsSubmit] = useState(false);

  const navigation = useNavigate();
  const location = useLocation();
  const state = location.state;
  const [userGroupData, setUserGroupData] = useState([]);
  const [targetUserGroupKeys, setTargetUserGroupKeys] = useState([]);
  const [userPermissionData, setUserPermissionData] = useState([]);
  const [targetUserPermissionKeys, setTargetUserPermissionKeys] = useState([]);
  const fetchUserGroup = async (values) => {
    const tempGroupTargetKeys = [];
    const tempGroupData = [];
    try {
      const response = await usersService.getUserGroups(accessToken, values);
      response.groupAll.forEach((item) => {
        const data = {
          key: item.id,
          title: item.name,
          description: `${item.id}-${item.name}`,
        };
        tempGroupData.push(data);
      });
      response.groupUser.forEach((item) => {
        tempGroupTargetKeys.push(item.id);
      });
      setUserGroupData(tempGroupData);
      setTargetUserGroupKeys(tempGroupTargetKeys);
    } catch (err) {
      console.error("[CreateUserManagementPage] fetchUserGroup: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }
  };

  const fetchUserPermission = async (values) => {
    const tempPermissionTargetKeys = [];
    const tempPermissionData = [];
    try {
      const response = await usersService.getUserPermission(accessToken, values);
      // response.permissionsAll.map((item) => {
      //   const data = {
      //     key: item.id,
      //     title: item.name,
      //     description: `${item.id}-${item.name}`,
      //   }
      //   tempPermissionData.push(data)
      // })
      // response.permissionsUser.map((item) => {
      //   const data = {
      //     key: item.id,
      //     title: item.name,
      //     description: `${item.id}-${item.name}`,
      //   }
      //   tempPermissionTargetKeys.push(data)
      // })

      response.permissionsAll.forEach((item) => {
        const data = {
          key: item.id,
          title: item.name,
          description: `${item.id}-${item.name}`,
        };
        tempPermissionData.push(data);
      });
      response.permissionsUser.forEach((item) => {
        tempPermissionTargetKeys.push(item.id);
      });
      setUserPermissionData(tempPermissionData);
      setTargetUserPermissionKeys(tempPermissionTargetKeys);
    } catch (err) {
      console.error("[CreateUserManagementPage] fetchUserPermission: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }
  };

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const onFinish = (values) => {
    setIsSubmit(true);
    if (stateType == TYPE_CREATE) {
      createUser();
    } else {
      updateUser(values);
    }
  };

  const createUser = async () => {
    await formUser.validateFields();
    const values = await formUser.getFieldsValue();
    if (values.password !== values.confirm_password) {
      openNotificationWithIcon(
        settings.NotificationType.ERROR,
        <>{"ERROR."}</>,
        <>{"Password do not match. Please try again!"}</>
      );
      return;
    }
    values.date_joined = dateJoined || dayjs();
    setLoading(true);
    try {
      const response = await usersService.createUser(accessToken, values);
      if (response !== null || response != undefined) {
        openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Create User success"}</>);
        setTimeout(() => {
          navigation("/usermanagement/user");
        }, 2000);
        setLoading(false);
      }
    } catch (err) {
      console.error("[CreateUserManagementPage] createUser: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }
  };

  const buildPrepareUpdatePayload = useCallback(
    (values, password) => {
      const payload = {
        id: userData.id,
        username: values.username,
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        date_joined: values.date_joined,
        nick_name: toNickNameOrNull(values.nick_name),
        language: values.language,
        is_active: values.is_active,
        is_superuser: values.is_superuser,
        is_staff: values.is_staff,
        company_id: toIdOrNull(values.company_id),
        sale_id: toIdOrNull(values.sale_id),
        customer_id: toIdOrNull(values.customer_id),
        origin_id: toIdOrNull(values.origin_id),
        destination_id: toIdOrNull(values.destination_id),
        manager_id: toIdOrNull(values.manager_id),
        user_groups: values.user_group || targetUserGroupKeys,
        user_permissions: values.user_permission || targetUserPermissionKeys,
      };
      if (password) {
        payload.password = password;
      }
      return payload;
    },
    [userData.id, targetUserGroupKeys, targetUserPermissionKeys]
  );

  const updateUser = async (value) => {
    const { id } = userData;
    value.id = id;
    clearAutofillPasswordFields();
    await formUser.validateFields();
    const values = await formUser.getFieldsValue();
    const prepareUpdate = buildPrepareUpdatePayload(values);

    setLoading(true);
    try {
      const response = await usersService.updateUser(accessToken, prepareUpdate);
      if (response !== null || response != undefined) {
        openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Update User success"}</>);
        setTimeout(() => {
          navigation("/usermanagement/user");
        }, 2000);
        setLoading(false);
      }
    } catch (err) {
      console.error("[CreateUserManagementPage] updateUser: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }
  };

  const validateConfirmPassword = async (_, value) => {
    const values = await formUser.getFieldsValue();
    const { password } = values;
    if (value === password) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Password do not match. Please try again!"));
  };

  const validateCreateUser = async (_, value) => {
    const values = await formUser.getFieldsValue();
    const { password } = values;
    if (isPassword.test(password)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("validate password fail. Please try again!"));
  };

  // โหมดแก้ไข + superuser: ไม่กรอก password ได้ ไม่ต้อง validate
  const validatePasswordOptional = async (_, value) => {
    if (stateType === TYPE_EDIT && !value?.trim()) return Promise.resolve();
    return validateCreateUser(_, value);
  };
  const validatePasswordLength = (_, value) => {
    if (stateType === TYPE_EDIT && !value?.trim()) return Promise.resolve();
    if (value?.length < 8) return Promise.reject(new Error("Password must be minimum 8 characters."));
    if (value?.length > 16) return Promise.reject(new Error("Password must be maximum 16 characters."));
    return Promise.resolve();
  };
  const validateConfirmPasswordOptional = async (_, value) => {
    const password = formUser.getFieldValue("password");
    if (stateType === TYPE_EDIT && !password?.trim()) return Promise.resolve();
    if (stateType === TYPE_EDIT && password?.trim() && !value?.trim())
      return Promise.reject(new Error("Please input confirm_password!"));
    if (stateType === TYPE_EDIT && !value?.trim()) return Promise.resolve();
    return validateConfirmPassword(_, value);
  };

  const validateResetPasswordFormat = async (_, value) => {
    if (!value?.trim()) {
      return Promise.reject(new Error(t("Create_User.Reset_Password.Required")));
    }
    if (!isPassword.test(value)) {
      return Promise.reject(new Error(t("Create_User.Reset_Password.Invalid_Format")));
    }
    return Promise.resolve();
  };

  const validateResetPasswordLength = (_, value) => {
    if (!value?.trim()) return Promise.resolve();
    if (value.length < 8) {
      return Promise.reject(new Error(t("Create_User.Reset_Password.Min_Length")));
    }
    if (value.length > 16) {
      return Promise.reject(new Error(t("Create_User.Reset_Password.Max_Length")));
    }
    return Promise.resolve();
  };

  const validateResetPasswordConfirm = async (_, value) => {
    const newPassword = resetPasswordForm.getFieldValue("new_password");
    if (value !== newPassword) {
      return Promise.reject(new Error(t("Create_User.Reset_Password.Mismatch")));
    }
    return Promise.resolve();
  };

  const closeResetPasswordModal = () => {
    setResetPasswordModalOpen(false);
    resetPasswordForm.resetFields();
  };

  const handleResetPasswordSubmit = async () => {
    try {
      await resetPasswordForm.validateFields();
      await formUser.validateFields();
      const values = formUser.getFieldsValue();
      const { new_password } = resetPasswordForm.getFieldsValue();
      const prepareUpdate = buildPrepareUpdatePayload(values, new_password);

      setResetPasswordLoading(true);
      const response = await usersService.updateUser(accessToken, prepareUpdate);
      if (response !== null && response !== undefined) {
        openNotificationWithIcon(
          settings.NotificationType.SUCCESS,
          t("Create_User.Reset_Password.Success_Title"),
          t("Create_User.Reset_Password.Success_Description")
        );
        closeResetPasswordModal();
      }
    } catch (err) {
      if (err?.errorFields) return;
      console.error("[CreateUserManagementPage] handleResetPasswordSubmit: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
    } finally {
      setResetPasswordLoading(false);
    }
  };

  const items = [
    { title: t("Page_Body_Tab_Menu.Home", { ns: "menus" }) },
    { title: t("Page_Body_Tab_Menu.Menu", { ns: "menus" }) },
    { title: <a href="/usermanagement/user">{t("Title_User")}</a> },
    {
      title: (
        <a style={{ fontWeight: 600, color: "black" }}>
          {stateType == TYPE_EDIT ? `${t("Create_User.Title_Edit_User")}` : `${t("Create_User.Title_Create_User")}`}
        </a>
      ),
    },
  ];

  const fetchCustomize = useCallback(
    async (param) => {
      setLoading(true);
      let managers = [];
      let origin = [];
      let destination = [];
      try {
        const dataManagers = await usersService.getUserManagers(accessToken);
        const data = await companyManagementService.getCompanysList(accessToken);
        const dataWareHouses = await originPackageService.getWareHouses(accessToken);
        dataManagers.map((value) => {
          managers.push({
            value: value.id,
            label: `${value.manager_code}(${value.manager_name ?? value.manager_code})`,
          });
        });
        setListUserManagerData(managers);

        data.map((value) => {
          company.push({
            id: value.id,
            company_name: value.company_name,
            company_code: value.company_code,
            sale: value.app_sale,
            customer: value.app_customer,
          });
        });
        setCompany(company);
        await filterCompanySale();
        await filterCompanyCustomer();

        dataWareHouses.map((value) => {
          if (value.is_origin === true) {
            origin.push({
              value: value.id,
              label: `${value.warehouse_code}`,
            });
          }
          if (value.is_destination === true) {
            destination.push({
              value: value.id,
              label: `${value.warehouse_code}`,
            });
          }
        });
        setListWareHouseDestination(destination);
        setListWareHouseOrigin(origin);
      } catch (err) {
        console.error("[CreateUserManagementPage] fetchCustomize: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        setLoading(false);
      }
      setLoading(false);
    },
    [accessToken]
  );

  const filterCompanySale = async (companyId) => {
    setListUserSalesData([]);
    let resCompany = [];
    let resCompanySales = [];
    company.map((list, index) => {
      resCompany.push({
        key: `company-${index}-${list.id}`,
        value: list.id,
        label: `${list.company_name}(${list.company_code})`,
      });
      if (companyId !== undefined && companyId == list.id) {
        let sale = list.sale;
        if (sale.length > 0) {
          sale.map((listSale, index) => {
            resCompanySales.push({
              key: `sale-${index}-${listSale.id}`,
              value: listSale.id,
              label: `${listSale.sale_name}(${list.company_code}-${listSale.sale_name})`,
            });
          });
          setIsValidateSaleId(true);
        }
      }
    });
    const uniqueOptions = Array.from(new Map(resCompany.map((item) => [item.value, item])).values());
    setListUserCompanyData(uniqueOptions);
    let valueSale = resCompanySales.filter(
      (oldValue, index) => index === resCompanySales.findIndex((data) => data.value === oldValue.value)
    );
    setListUserSalesData(valueSale);
  };

  const filterCompanyCustomer = async (companyId) => {
    setListUserCustomerData([]);
    let resCompany = [];
    let resCompanyCustomer = [];
    company.map((list, index) => {
      resCompany.push({
        key: `company-${index}-${list.id}`,
        value: list.id,
        label: `${list.company_name}(${list.company_code})`,
      });
      if (companyId !== undefined && companyId == list.id) {
        let customer = list.customer;

        if (customer && customer.length > 0) {
          customer.map((listCustomer, index) => {
            resCompanyCustomer.push({
              key: `customer-${index}-${listCustomer.id}`,
              value: listCustomer.id,
              label: `${list.company_code}(${
                listCustomer.app_sale ? listCustomer.app_sale.sale_name : ""
              }-${listCustomer.customer_code})`,
            });
          });
          setIsValidateCustomerId(true);
        }
      }
    });
    let valueCustomer = resCompanyCustomer.filter(
      (oldValue, index) => index === resCompanyCustomer.findIndex((data) => data.value === oldValue.value)
    );
    setListUserCustomerData(valueCustomer);
  };

  const handlerOnChangeCompany = useCallback(async (companyId) => {
    formUser.setFieldValue("sale_id", null);
    formUser.setFieldValue("customer_id", null);
    setIsValidateSaleId(false);
    setIsValidateCustomerId(false);
    await filterCompanySale(companyId);
    await filterCompanyCustomer(companyId);
  }, []);

  const handleSearchCompany = async (value) => {
    if (!value) {
      setSearchCompanyData("");
    } else if (value !== searchCompanyData) {
      setSearchCompanyData("");
    }
    setSearchCompanyData(value);
    await filterCompanySale(value);
  };

  const handleChangeSale = (value) => {
    setSaleId(value);
  };

  const handlerOnChangeCustomer = (value) => {
    setCustomerId(value);
  };

  const setDetailData = async (data) => {
    // Non-Select fields first (these do not depend on option lists).
    formUser.setFieldValue("username", data.username);
    formUser.setFieldValue("first_name", data.first_name);
    formUser.setFieldValue("last_name", data.last_name);
    formUser.setFieldValue("email", data.email);
    formUser.setFieldValue("is_active", data.is_active);
    formUser.setFieldValue("is_staff", data.is_staff);
    formUser.setFieldValue("last_login", data.last_login);
    formUser.setFieldValue("date_joined", new Date(data.date_joined));
    formUser.setFieldValue("nick_name", data.nick_name ?? null);
    formUser.setFieldValue("is_superuser", data.is_superuser);
    formUser.setFieldValue("language", data.language.toUpperCase());
    clearAutofillPasswordFields();

    // Preload sales/customer option lists for the user's current company BEFORE
    // writing Select values. Otherwise Ant Design renders the raw numeric id
    // when it cannot find a matching option in the (still-empty) list.
    const companyId = data.app_company?.id ?? null;
    if (companyId != null) {
      await filterCompanySale(companyId);
      await filterCompanyCustomer(companyId);
    }

    // Now write Select values — all option lists are populated in this render.
    const managerId = data.app_manager?.id ?? data.app_manager?.manager_id ?? data.manager_id ?? null;
    formUser.setFieldValue("manager_id", managerId ?? null);
    formUser.setFieldValue("company_id", companyId);

    const saleId = data.app_sale?.id ?? null;
    formUser.setFieldValue("sale_id", saleId);
    if (saleId != null) setIsValidateSaleId(true);

    const customerId = data.app_customer?.id ?? null;
    formUser.setFieldValue("customer_id", customerId);
    if (customerId != null) setIsValidateCustomerId(true);

    formUser.setFieldValue("origin_id", data.app_warehouse_app_user_origin_idToapp_warehouse?.id ?? null);
    formUser.setFieldValue(
      "destination_id",
      data.app_warehouse_app_user_destination_idToapp_warehouse?.id ?? null
    );
  };

  useEffect(() => {
    if (hasFetched.current) return; // ตรวจสอบว่าถูกยิงไปแล้วหรือยัง
    hasFetched.current = true;
    if (!accessToken) return;
    setIsSubmit(false);
    // Await fetchCustomize first so option lists (company/manager/warehouses) are
    // populated before setDetailData writes form values. Without this, the Select
    // components render raw numeric IDs instead of matching option labels.
    const init = async () => {
      await fetchCustomize();
      if (state?.type == TYPE_EDIT) {
        await Promise.all([fetchUserGroup(state.value), fetchUserPermission(state.value)]);
        setStateType(TYPE_EDIT);
        setUserData(state.value);
        await setDetailData(state.value);
        setDateJoined(state.value.date_joined);
        setLastLogin(state.value.last_login);
      }
    };
    init();
  }, [accessToken, userData, lastLogin, dateJoined, state]);

  // Chrome อาจ autofill password ช้ากว่า render — ล้างซ้ำจนกว่าจะไม่มีช่อง password บนหน้าแก้ไข
  useEffect(() => {
    if (stateType !== TYPE_EDIT) return;
    clearAutofillPasswordFields();
    const timers = [100, 300, 1000].map((ms) => setTimeout(clearAutofillPasswordFields, ms));
    return () => timers.forEach(clearTimeout);
  }, [stateType, clearAutofillPasswordFields]);

  const filterOptionManager = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const filterOptionCompany = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const filterOptionSale = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const filterOptionCustomer = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const filterOptionOrigin = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  const filterOptionDestination = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  // group
  const filterOptionGroup = (inputValue, option) =>
    (option?.description ?? "").toLowerCase().includes(inputValue.toLowerCase());
  const handleChangeGroup = (newTargetKeys) => {
    setTargetUserGroupKeys(newTargetKeys);
  };

  // permission
  const filterOptionPermission = (inputValue, option) =>
    (option?.description ?? "").toLowerCase().includes(inputValue.toLowerCase());
  const handleChangePermission = (newTargetKeys) => {
    setTargetUserPermissionKeys(newTargetKeys);
  };

  const selectLanguage = [
    {
      value: "TH",
      label: "TH",
    },
    {
      value: "EN",
      label: "EN",
    },
  ];

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row style={{ overflowX: "auto" }}>
          <Col span={24}>
            <Breadcrumb items={items} />
            <Row style={{ padding: "15px 0px 0px 0px" }}>
              <Col span={12}>
                <Title level={4} style={{ textWrap: "nowrap", display: "flex", gap: "7px" }}>
                  <ArrowLeftOutlined style={{ fontSize: "20px" }} />
                  {stateType === TYPE_EDIT
                    ? `${t("Create_User.Title_Edit_User")}`
                    : `${t("Create_User.Title_Create_User")}`}
                </Title>
              </Col>
            </Row>
            <Divider />
            <Row style={{ padding: "15px 0px 0px 0px" }}>
              <Col span={12}>
                <Title level={4} style={{ textWrap: "nowrap", display: "flex", gap: "7px" }}>
                  {`${t("Create_User.Personal_Information.Title")}`}
                </Title>
              </Col>
            </Row>
            <Form
              form={formUser}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              style={{ maxWidth: "50%", minWidth: 360, marginTop: "3%" }}
              autoComplete={stateType === TYPE_EDIT ? "off" : undefined}
              onFinish={onFinish}
            >
              <Form.Item
                label={t("Create_User.Personal_Information.Username")}
                name="username"
                rules={[{ required: true, whitespace: true, message: "Please input code!" }]}
              >
                <Input
                  allowClear="true"
                  autoComplete={stateType === TYPE_EDIT ? "off" : "username"}
                  placeholder={t("Create_User.Personal_Information.Username")}
                  style={{ minWidth: 200 }}
                />
              </Form.Item>
              {stateType === TYPE_EDIT && hasPermission(permissions.User.CHANGE) && (
                <Form.Item wrapperCol={{ offset: 6, span: 18 }}>
                  <Button type="default" onClick={() => setResetPasswordModalOpen(true)}>
                    {t("Create_User.Reset_Password.Button")}
                  </Button>
                </Form.Item>
              )}
              {stateType === TYPE_CREATE && (
                <>
                  <Form.Item
                    label={t("Create_User.Personal_Information.Password")}
                    name="password"
                    rules={[
                      { required: true, message: "Please input password!" },
                      { validator: validatePasswordOptional },
                      { validator: validatePasswordLength },
                    ]}
                  >
                    <Input.Password
                      autoComplete="new-password"
                      min={8}
                      max={16}
                      placeholder={t("Create_User.Personal_Information.Password")}
                      iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                      style={{ minWidth: 200 }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={t("Create_User.Personal_Information.Password_Confirm")}
                    name="confirm_password"
                    rules={[
                      { required: true, message: "Please input confirm_password!" },
                      { validator: validateConfirmPasswordOptional },
                    ]}
                  >
                    <Input.Password
                      autoComplete="new-password"
                      placeholder={t("Create_User.Personal_Information.Password_Confirm")}
                      iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                      style={{ minWidth: 200 }}
                    />
                  </Form.Item>
                </>
              )}
              <Form.Item
                label={t("Create_User.Personal_Information.First_Name")}
                name="first_name"
                rules={[{ required: true, whitespace: true, message: "Please input first_name!" }]}
              >
                <Input
                  allowClear="true"
                  placeholder={t("Create_User.Personal_Information.First_Name")}
                  style={{ minWidth: 200 }}
                />
              </Form.Item>
              <Form.Item
                label={t("Create_User.Personal_Information.Last_Name")}
                name="last_name"
                rules={[{ required: true, whitespace: true, message: "Please input last_name!" }]}
              >
                <Input
                  allowClear="true"
                  placeholder={t("Create_User.Personal_Information.Last_Name")}
                  style={{ minWidth: 200 }}
                />
              </Form.Item>
              <Form.Item
                label={t("Create_User.Personal_Information.Email")}
                name="email"
                rules={[{ type: "email", required: true, whitespace: true, message: "Please input email!" }]}
              >
                <Input
                  allowClear="true"
                  placeholder={t("Create_User.Personal_Information.Email")}
                  style={{ minWidth: 200 }}
                />
              </Form.Item>
              {stateType === TYPE_EDIT && (
                <>
                  <Divider />
                  <Row style={{ padding: "15px 0px 0px 0px" }}>
                    <Col span={12}>
                      <Title
                        level={4}
                        style={{
                          textWrap: "nowrap",
                          display: "flex",
                          gap: "7px",
                        }}
                      >
                        {`${t("Create_User.Permission.Title")}`}
                      </Title>
                    </Col>
                  </Row>
                  <Form.Item name="is_active" valuePropName="checked">
                    <Checkbox>{t("Create_User.Permission.Active")}</Checkbox>
                  </Form.Item>
                  <Form.Item name="is_staff" valuePropName="checked">
                    <Checkbox>{t("Create_User.Permission.Staff_Status")}</Checkbox>
                  </Form.Item>
                  <Form.Item name="is_superuser" valuePropName="checked">
                    <Checkbox>{t("Create_User.Permission.Superuser_Status")}</Checkbox>
                  </Form.Item>
                  <Form.Item label={t("Create_User.Permission.Group")} name="user_group" key="user_group">
                    <Transfer
                      listStyle={{ width: 500, height: 500 }}
                      dataSource={userGroupData}
                      targetKeys={targetUserGroupKeys} // Ensure this is an array of strings (keys)
                      filterOption={filterOptionGroup}
                      onChange={handleChangeGroup}
                      showSearch
                      render={(item) => item.title}
                    />
                  </Form.Item>
                  <Form.Item
                    label={t("Create_User.Permission.User_Permission")}
                    name="user_permission"
                    key="user_permission"
                  >
                    <Transfer
                      listStyle={{ width: 500, height: 500 }}
                      dataSource={userPermissionData}
                      showSearch
                      filterOption={filterOptionPermission}
                      targetKeys={targetUserPermissionKeys}
                      onChange={handleChangePermission}
                      render={(item) => item.title}
                      // showSelectAll={false}
                    />
                  </Form.Item>
                </>
              )}
              <Divider />
              <Row style={{ padding: "15px 0px 0px 0px" }}>
                <Col span={12}>
                  <Title level={4} style={{ textWrap: "nowrap", display: "flex", gap: "7px" }}>
                    {`${t("Create_User.Important_Date.Title")}`}
                  </Title>
                </Col>
              </Row>
              {stateType === TYPE_EDIT && (
                <>
                  <Form.Item label={t("Create_User.Important_Date.Last_Login")} name="last_login">
                    <Space direction="vertical" style={{ width: "100%", minWidth: 200 }}>
                      {/* <DatePicker
                        disabled
                        showTime
                        style={{width: '100%'}}
                        defaultValue={dayjs(lastLogin, dateFormat)}
                      /> */}
                      <Input
                        disabled
                        allowClear="true"
                        value={
                          lastLogin && lastLogin !== null ? dayjs(lastLogin).format("YYYY-MM-DD HH:mm:ss") : "not login"
                        }
                        style={{ minWidth: 200 }}
                      />
                    </Space>
                  </Form.Item>
                </>
              )}
              <Form.Item label={t("Create_User.Important_Date.Date_Joined")} name="date_joined">
                <Space direction="vertical" style={{ width: "100%", minWidth: 200 }}>
                  {stateType === TYPE_EDIT ? (
                    <Input
                      disabled
                      allowClear="true"
                      value={dayjs(dateJoined).format("YYYY-MM-DD HH:mm:ss")}
                      style={{ minWidth: 200 }}
                    />
                  ) : (
                    <DatePicker
                      disabled={stateType === TYPE_EDIT ? true : false}
                      showTime
                      defaultValue={dayjs()}
                      style={{ width: "100%", minWidth: 200 }}
                      onChange={(value, dateString) => {
                        setDateJoined(dateString);
                      }}
                    />
                  )}
                </Space>
              </Form.Item>
              <Divider />
              <Row style={{ padding: "15px 0px 0px 0px" }}>
                <Col span={12}>
                  <Title level={4} style={{ textWrap: "nowrap", display: "flex", gap: "7px" }}>
                    {`${t("Create_User.Customize.Title")}`}
                  </Title>
                </Col>
              </Row>
              <Form.Item
                label={t("Create_User.Customize.NickName")}
                name="nick_name"
                rules={[{ whitespace: true, message: "Please input nick_name!" }]}
              >
                <Input allowClear="true" placeholder={t("Create_User.Customize.NickName")} style={{ minWidth: 200 }} />
              </Form.Item>
              <Form.Item
                label={t("Create_User.Customize.Manager") + ":"}
                name="manager_id"
                style={{ marginBottom: "1rem" }}
                rules={[
                  ...(isSuperuser
                    ? []
                    : [
                        {
                          required: true,
                          message: "กรุณาเลือกผู้จัดการ (manager)",
                        },
                      ]),
                ]}
              >
                <Select
                  style={{ width: "100%", minWidth: 200 }}
                  showSearch
                  allowClear
                  placeholder={t("Please_Select", { ns: "common" })}
                  options={listUserManagerData}
                  filterOption={filterOptionManager}
                  disabled={!isSuperuser && listUserManagerData.length === 0}
                />
              </Form.Item>
              <Form.Item
                label={t("Create_User.Customize.Company") + ":"}
                name="company_id"
                style={{ marginBottom: "1rem" }}
              >
                <Select
                  style={{ width: "100%", minWidth: 200 }}
                  showSearch
                  allowClear
                  onSearch={handleSearchCompany}
                  placeholder={t("Please_Select", { ns: "common" })}
                  options={listUserCompanyData}
                  filterOption={filterOptionCompany}
                  onChange={handlerOnChangeCompany}
                />
              </Form.Item>
              <Form.Item label={t("Create_User.Customize.Sales") + ":"} name="sale_id" style={{ marginBottom: "1rem" }}>
                <Select
                  style={{ width: "100%", minWidth: 200 }}
                  showSearch
                  allowClear
                  placeholder={t("Please_Select", { ns: "common" })}
                  options={listUserSalesData}
                  filterOption={filterOptionSale}
                  onChange={handleChangeSale}
                />
              </Form.Item>
              <Form.Item
                label={t("Create_User.Customize.Customer") + ":"}
                name="customer_id"
                style={{ marginBottom: "1rem" }}
              >
                <Select
                  style={{ width: "100%", minWidth: 200 }}
                  showSearch
                  allowClear
                  placeholder={t("Please_Select", { ns: "common" })}
                  options={listUserCustomerData}
                  filterOption={filterOptionCustomer}
                  onChange={handlerOnChangeCustomer}
                />
              </Form.Item>
              <Form.Item
                label={t("Create_User.Customize.Origin") + ":"}
                name="origin_id"
                style={{ marginBottom: "1rem" }}
              >
                <Select
                  style={{ width: "100%", minWidth: 200 }}
                  showSearch
                  allowClear
                  placeholder={t("Please_Select", { ns: "common" })}
                  options={listWareHouseOrigin}
                  filterOption={filterOptionOrigin}
                />
              </Form.Item>
              <Form.Item
                label={t("Create_User.Customize.Destination") + ":"}
                name="destination_id"
                style={{ marginBottom: "1rem" }}
              >
                <Select
                  style={{ width: "100%", minWidth: 200 }}
                  showSearch
                  allowClear
                  placeholder={t("Please_Select", { ns: "common" })}
                  options={listWareHouseDestination}
                  filterOption={filterOptionDestination}
                />
              </Form.Item>
              <Form.Item
                label={t("Create_User.Customize.Language") + ":"}
                name="language"
                key="language"
                style={{ marginBottom: "1rem" }}
                rules={[{ required: true, whitespace: true, message: "Please input code!" }]}
              >
                <Select
                  style={{ width: "100%", minWidth: 200 }}
                  placeholder={t("Please_Select", { ns: "common" })}
                  options={selectLanguage}
                  // onChange={handlerOnChangeLanguage}
                />
              </Form.Item>

              <Row align="middle" justify="end" style={{ marginTop: "20px" }}>
                <Form.Item>
                  <Space>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={loading}
                      loading={loading}
                    >
                      {t("BTN_Save", { ns: "buttons" })}
                    </Button>
                    <Button
                      htmlType="button"
                      onClick={() => {
                        navigation("/usermanagement/user");
                      }}
                    >
                      {t("BTN_Cancel", { ns: "buttons" })}
                    </Button>
                  </Space>
                </Form.Item>
              </Row>
            </Form>
          </Col>
        </Row>
      </Spin>
      <Modal
        title={t("Create_User.Reset_Password.Title")}
        open={resetPasswordModalOpen}
        onCancel={closeResetPasswordModal}
        footer={null}
        destroyOnClose
        maskClosable={!resetPasswordLoading}
      >
        <Form form={resetPasswordForm} layout="vertical" autoComplete="off">
          <Form.Item
            label={t("Create_User.Reset_Password.New_Password")}
            name="new_password"
            rules={[
              { required: true, message: t("Create_User.Reset_Password.Required") },
              { validator: validateResetPasswordFormat },
              { validator: validateResetPasswordLength },
            ]}
          >
            <Input.Password
              autoComplete="new-password"
              minLength={8}
              maxLength={16}
              placeholder={t("Create_User.Reset_Password.New_Password")}
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
          </Form.Item>
          <Form.Item
            label={t("Create_User.Reset_Password.Confirm_Password")}
            name="confirm_new_password"
            rules={[
              { required: true, message: t("Create_User.Reset_Password.Confirm_Required") },
              { validator: validateResetPasswordConfirm },
            ]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t("Create_User.Reset_Password.Confirm_Password")}
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Space style={{ width: "100%", justifyContent: "flex-end" }}>
              <Button onClick={closeResetPasswordModal} disabled={resetPasswordLoading}>
                {t("BTN_Cancel", { ns: "buttons" })}
              </Button>
              <Button type="primary" loading={resetPasswordLoading} onClick={handleResetPasswordSubmit}>
                {t("Create_User.Reset_Password.Submit")}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
